export default __webpack_public_path__ + "static/media/pETHo.d4291a7a.svg";